var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscussionIconCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0526 1C7.32449 1 1 8.12068 1 16.0225C1 18.5463 1.7361 21.1452 3.02804 23.5188C3.2684 23.9094 3.29845 24.4051 3.1332 24.8708L2.12669 28.2359C1.90135 29.0471 2.59239 29.648 3.35854 29.4076L6.39309 28.5063C7.21933 28.2359 7.8653 28.5814 8.63295 29.0471C10.8262 30.339 13.5588 31 16.0225 31C23.4737 31 31.0451 25.2464 31.0451 15.9775C31.0451 7.98548 24.5854 1 16.0526 1Z",
    fill: "#7C85AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9932 17.9606C14.9266 17.9456 14.0703 17.0893 14.0703 16.0227C14.0703 14.9711 14.9416 14.0998 15.9932 14.1148C17.0598 14.1148 17.9161 14.9711 17.9161 16.0377C17.9161 17.0893 17.0598 17.9606 15.9932 17.9606ZM9.06717 17.9605C8.01559 17.9605 7.14429 17.0892 7.14429 16.0376C7.14429 14.971 8.00057 14.1147 9.06717 14.1147C10.1338 14.1147 10.9901 14.971 10.9901 16.0376C10.9901 17.0892 10.1338 17.9455 9.06717 17.9605ZM20.9954 16.0377C20.9954 17.0893 21.8517 17.9606 22.9183 17.9606C23.9849 17.9606 24.8412 17.0893 24.8412 16.0377C24.8412 14.9711 23.9849 14.1148 22.9183 14.1148C21.8517 14.1148 20.9954 14.9711 20.9954 16.0377Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussionIconCreate);
export default __webpack_public_path__ + "static/media/discussion-icon-create.461924eae37798c5ab9ed57af7d64515.svg";
export { ForwardRef as ReactComponent };